export class LivenessResult {
  //Array of pictures (liveness session proof)
  proof: Array<Blob>;
  //Result picture
  picture: string;
}
export class FaceStateModel {
  faceImage: any;
  matchResult: boolean;
  matchLoading: boolean;
  matchLoaded: boolean;
  isLoaded: boolean;
  isLoading: boolean;
  isError: boolean;
  isCameraOpen: boolean;
  isPadDisplayed: boolean;
  isFaceImageLoading: boolean;
  timeOut: boolean;
  errorType: ErrorType;
}
export enum ErrorType {
  PERMISSION_DENIED = 2,
  NO_CAMERA_FOUND,
  CAMERA_ABORT,
  CAMERA_NOT_READABLE,
  FACE_NOT_DETECTED = 422,
  UNSUFFICIANT_QUALITY = 200,
  INVALID_MEDIA_TYPE = 415
}
